import {
	Button,
	Dialog,
	LabelField,
	Loading,
	TextField,
	Title,
} from 'src/components';
import { type ChangeEvent, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { type RootState } from 'src/store';
import { getExamType } from 'src/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { userTypes } from '../../../../helpers/constants';
import CourseDrawerForm from '../CourseDrawerForm';
import Sections from './Sections';
import courseActions from 'src/store/Courses/actions';
import sectionActions from 'src/store/Sections/actions';
import useStyles from './CourseEdition-styles';

function CourseEdition() {
	const { courseId }: any = useParams();
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const classes = useStyles();
	const user = useSelector((state: RootState) => state.auth.data);
	const { course, isLoadingOne } = useSelector(
		(state: RootState) => state.courses,
	);

	const getCourse = (id: number) => dispatch(courseActions.getOne(id));
	const createSection = (name: string) =>
		dispatch(sectionActions.create({ courseId, name }));
	const getSections = (courseId: number) =>
		dispatch(sectionActions.getAll(courseId));

	const [drawerOpen, setDrawerOpen] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [sectionName, setSectionName] = useState('');

	// NOTE:
	// ./src/components/Reports/AdvancesDialog.tsx[39:5]

	function handleCreateSection() {
		createSection(sectionName);
		setDialogOpen(false);
		setSectionName('');
	}

	function handleDialogClose() {
		setDialogOpen(false);
		setSectionName('');
	}

	useEffect(() => {
		getCourse(courseId);
		getSections(courseId);
	}, [courseId]);

	return (
		<Loading isLoading={isLoadingOne}>
			<Grid container>
				<CourseDrawerForm
					courseId={courseId}
					from={'edition'}
					onClose={() => {
						setDrawerOpen(false);
					}}
					open={drawerOpen}
				/>

				<Dialog
					actions={
						<Button
							actionType={'save'}
							disabled={sectionName.length === 0}
							onClick={handleCreateSection}
						>
							Crear
						</Button>
					}
					content={
						<TextField
							label={'Nombre'}
							onChange={(e: ChangeEvent<HTMLInputElement>) => {
								setSectionName(e.target.value);
							}}
							value={sectionName}
						/>
					}
					handleOpen={handleDialogClose}
					maxWidth={'sm'}
					open={dialogOpen}
					title={'Nueva Sección'}
				/>

				<Grid item xs={9}>
					<Title
						breadcrumbs={[
							{ label: 'Cursos', link: '/app/courses' },
							{ label: course.name },
						]}
						title={course.name}
					/>
				</Grid>

				<Grid className={classes.buttonContainer} item xs={3}>
					{user.type === userTypes.ADMIN && (
						<Button
							actionType={'edit'}
							hideLabelOnMobile
							onClick={() => {
								setDrawerOpen(true);
							}}
						>
							Editar
						</Button>
					)}
				</Grid>

				<Grid container>
					<Grid
						item
						md={3}
						style={{ marginTop: 18, padding: 8 }}
						xs={12}
					>
						<LabelField
							className={classes.labelContainer}
							label={'Total de secciones'}
							value={course.totalSections}
						/>

						<LabelField
							className={classes.labelContainer}
							label={'Total de preguntas'}
							value={course.totalQuestions}
						/>

						<LabelField
							className={classes.labelContainer}
							label={'Total de preguntas en examen'}
							value={course.totalExamQuestions}
						/>

						<LabelField
							className={classes.labelContainer}
							label={'Calificación mínima'}
							value={course.minimumQualification}
						/>

						<LabelField
							className={classes.labelContainer}
							label={'Máximo de intentos'}
							value={course.maxAttempts}
						/>

						<LabelField
							className={classes.labelContainer}
							label={'Tipo de examen'}
							value={getExamType(course.exam || '')}
						/>
					</Grid>

					<Grid item md={9} xs={12}>
						<Sections courseId={courseId} />
					</Grid>
				</Grid>

				<Grid className={classes.buttonContainer} item xs={12}>
					{user.type === userTypes.ADMIN && (
						<Button
							actionType={'add'}
							backgroundColor={'white'}
							onClick={() => {
								setDialogOpen(true);
							}}
						>
							Agregar Sección
						</Button>
					)}
				</Grid>
			</Grid>
		</Loading>
	);
}

export default CourseEdition;
